function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.0273 11.5386C23.7655 10.9324 23.3881 10.3831 22.916 9.9214C22.4436 9.45833 21.8866 9.09033 21.2754 8.83742C20.6416 8.57412 19.9617 8.43935 19.2754 8.44093C18.3125 8.44093 17.373 8.7046 16.5566 9.20265C16.3613 9.32179 16.1758 9.45265 16 9.59523C15.8242 9.45265 15.6387 9.32179 15.4434 9.20265C14.627 8.7046 13.6875 8.44093 12.7246 8.44093C12.0312 8.44093 11.3594 8.57374 10.7246 8.83742C10.1113 9.09132 9.55859 9.45656 9.08398 9.9214C8.61132 10.3826 8.23375 10.932 7.97266 11.5386C7.70117 12.1694 7.5625 12.8394 7.5625 13.5288C7.5625 14.1792 7.69531 14.8569 7.95898 15.5464C8.17969 16.1226 8.49609 16.7202 8.90039 17.3237C9.54102 18.2788 10.4219 19.2749 11.5156 20.2847C13.3281 21.9585 15.123 23.1148 15.1992 23.1616L15.6621 23.4585C15.8672 23.5894 16.1309 23.5894 16.3359 23.4585L16.7988 23.1616C16.875 23.1128 18.668 21.9585 20.4824 20.2847C21.5762 19.2749 22.457 18.2788 23.0977 17.3237C23.502 16.7202 23.8203 16.1226 24.0391 15.5464C24.3027 14.8569 24.4355 14.1792 24.4355 13.5288C24.4375 12.8394 24.2988 12.1694 24.0273 11.5386ZM16 21.9136C16 21.9136 9.04688 17.4585 9.04688 13.5288C9.04688 11.5386 10.6934 9.92531 12.7246 9.92531C14.1523 9.92531 15.3906 10.7222 16 11.8862C16.6094 10.7222 17.8477 9.92531 19.2754 9.92531C21.3066 9.92531 22.9531 11.5386 22.9531 13.5288C22.9531 17.4585 16 21.9136 16 21.9136Z",
  fill: "#404047"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  width: 30.5,
  height: 30.5,
  rx: 15.25,
  stroke: "#404047",
  strokeWidth: 1.5
});

var SvgMedicalCondition = function SvgMedicalCondition(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedicalCondition, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medical-condition.d8b57f37.svg";
export { ForwardRef as ReactComponent };